import { cleanCommonParams } from './common';

const mapHolidayGiftRequestParams = (
    isCreate,
    {
        premier_status,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            form_entry: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapHolidayGiftRequestParams };
